import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { useStaticQuery } from 'gatsby'
import React from 'react'
import appStore from '../../images/app_store.svg'
import facebook from '../../images/facebook.svg'
import googlePlay from '../../images/google_play.svg'
import instagram from '../../images/instagram.svg'
import linkedIn from '../../images/linkedin.svg'
import portaleOfferte from '../../images/portale_offerte.svg'
import tuscanyLogos from '../../images/tuscany-logos.svg'
import { LINK_CLIENTI, linkToScopriPreventivo } from '../../links'
import { Colors } from '../../styles/colors'
import { Spacing } from '../../styles/spacing'
import { Typography } from '../../styles/typography'
import { cssOnlyDesktop, cssOnlyMobile, DESKTOP_MIN_WIDTH } from '../../styles/utils'
import { Section } from '../content'
import { FOOTER_QUERY, FooterContainer, FooterLink } from '../Footer'
import { SiteLink } from '../SiteLink'



const Social = ({ className }) => (<div className={className}>
    {/*<SiteLink to="//www.facebook.com/tate.it/" name={'Facebook'} css={[Spacing.Padding.right_8]}*/}
    {/*          target={'_blank'}*/}
    {/*          rel={'noreferrer nofollow'}>*/}
    {/*  <img src={facebook} alt="Facebook" width={24} height={24}/>*/}
    {/*</SiteLink>*/}
    {/*<SiteLink to="//www.instagram.com/tate_app/" name={'Instagram'} css={[Spacing.Padding.right_8]}*/}
    {/*          target={'_blank'}*/}
    {/*          rel={'noreferrer nofollow'}>*/}
    {/*  <img src={instagram} alt="Instagram" width={24} height={24}/>*/}
    {/*</SiteLink>*/}
    <SiteLink to="//www.linkedin.com/company/tate-it/" name={'LinkedIn'}
              target={'_blank'}
              rel={'noreferrer nofollow'}>
      <img src={linkedIn} alt="LinkedIn" width={24} height={24}/>
    </SiteLink>
  </div>
)
const BlogFooterLink = styled(FooterLink)`
    margin-bottom: 0px;
    margin-right: 8px;
    @media (max-width: ${DESKTOP_MIN_WIDTH}) {
      margin-right: 0px;
      margin-bottom: 12px;
    }

`
export const BlogFooter = (props) => {
  const {web} = useStaticQuery(FOOTER_QUERY)

  return (
    <FooterContainer {...props}>
      <Section noSpacing css={[Spacing.Margin.top_80, Spacing.Margin.bottom_40]}>
        <div>
          {/* Desktop Menu */}
          <div css={[Spacing.Flex.row, css`justify-content: space-between;` ]} className={'d-none d-lg-flex'}>
            <div css={[Spacing.Flex.vertical_center]}>
            <BlogFooterLink label={'Chi siamo'} link={'/about-us'}/>
            <BlogFooterLink label={'Contatti'} link={'/legal/contatti'}/>
            <BlogFooterLink label={'Cookie'} link={'//tate.it/help/qual-e-la-cookie-policy-di-tate'}/>
            <BlogFooterLink label={'Privacy Policy'} link={'/legal/privacy-policy'}/>
            <BlogFooterLink label={'Note Legali'} link={'/legal/note-legali'}/>
            </div>
            <Social css={[Spacing.Flex.vertical_center, css`justify-self: end; height:24px; margin-bottom: -2px;`]}/>
          </div>

          {/* Mobile Menu */}
          <div className={'d-flex d-lg-none '}>
            <div css={[Spacing.Flex.flex_1]}>
              <BlogFooterLink label={'Chi siamo'} link={'/about-us'}/>
              <BlogFooterLink label={'Cookie'} link={'//tate.it/help/qual-e-la-cookie-policy-di-tate'}/>
              <BlogFooterLink label={'Note Legali'} link={'/legal/note-legali'}/>
            </div>
            <div css={[Spacing.Flex.flex_1]}>
              <BlogFooterLink label={'Contatti'} link={'/legal/contatti'}/>
              <BlogFooterLink label={'Privacy Policy'} link={'/legal/privacy-policy'}/>
            </div>
          </div>
          </div>
        <div className={'d-flex d-lg-none '} style={{marginTop: '40px'}}>
          <Social/>
        </div>
        {/*Disclaimer*/}
        <div css={[Spacing.Margin.top_32]} className={'row'}>
          <div className="col col-12">
            <span css={[Typography.label.label4_400, Colors.Color.eerieBlack600]}>
            Tate è una Società a Responsabilità Limitata - P.IVA {web.partita_iva} - Capitale Sociale I.V. di {web.capitale_sociale} | Copyright ©{new Date().getFullYear()} Tate s.r.l. - Tutti i diritti riservati
          </span>
          </div>
        </div>
      </Section>
    </FooterContainer>
  )
}
